import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { CmsArticle } from '@fcom/core-api/';
import { FragmentService } from '@fcom/common/services';

@Component({
  selector: 'fin-trip-message',
  templateUrl: './trip-message.component.html',
  styleUrls: ['./trip-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TripMessageComponent implements OnInit {
  private fragmentService = inject(FragmentService);

  @Input() fragmentKey: string;

  tripMessage$: Observable<CmsArticle>;

  ngOnInit(): void {
    this.tripMessage$ = this.fragmentService.getFragment<CmsArticle>(this.fragmentKey);
  }
}
